<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-card>
        <v-layout row wrap pa-3>
          <v-flex lg12 md12 sm12>
            <div v-if="customerId > 0">
              Tên đăng nhập:
              <b>{{ currentCustomer.Username }}</b>
            </div>
            <v-text-field
              :disabled="!roleEditable"
              v-if="customerId === 'tao-moi'"
              label="Tên đăng nhập"
              v-model="currentCustomer.Username"
              class="input-group--focused"
              :rules="nameRules"
            ></v-text-field>
          </v-flex>
          <v-flex lg6 md6 sm12>
            <v-text-field
              label="Họ"
              v-model="currentCustomer.FirstName"
              class="input-group--focused"
              :rules="requireRules"
            ></v-text-field>
          </v-flex>
          <v-flex lg6 md6 sm12>
            <v-text-field
              label="Tên"
              v-model="currentCustomer.LastName"
              class="input-group--focused"
              :rules="requireRules"
            ></v-text-field>
          </v-flex>
          <v-flex lg6 md6 sm12>
            <v-layout row v-if="roleAdmin || !currentCustomer.ID">
              <v-flex lg12>
                <v-text-field
                  label="Điện thoại"
                  v-model="currentCustomer.PhoneNumber"
                  class="input-group--focused"
                  :rules="requireRules"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex lg6 md6 sm12>
            <v-text-field
              label="Email"
              v-model="currentCustomer.Email"
              class="input-group--focused"
            ></v-text-field>
          </v-flex>
          <v-flex lg12 md12 sm12>
            <v-text-field
              label="Địa chỉ"
              v-model="currentCustomer.Address"
              class="input-group--focused"
              :rules="requireRules"
            ></v-text-field>
          </v-flex>
          <v-flex lg6 md12 sm12>
            <v-select
              label="Kho TQ"
              class="input-group--focused"
              :items="chinaStores"
              v-model="currentCustomer.ChinaStoreID"
              item-text="Name"
              item-value="ID"
            ></v-select>
          </v-flex>
          <v-flex lg6 md12 sm12>
            <v-select
              label="Kho VN"
              class="input-group--focused"
              :items="warehouses"
              v-model="currentCustomer.ReceivePlaceID"
              item-text="Name"
              item-value="ID"
            ></v-select>
          </v-flex>
          <v-flex lg4 md4 sm12>
            <v-select
              :disabled="!roleEditable"
              label="Nhân viên hỗ trợ"
              :items="cs_staffs"
              v-model="currentCustomer.CustomerServiceID"
              item-text="FullName"
              item-value="ID"
            ></v-select>
          </v-flex>
          <v-flex lg4 md4 sm12>
            <v-select
              :disabled="!roleEditable"
              label="Nhân viên đặt hàng"
              :items="p_staffs"
              v-model="currentCustomer.BuyerID"
              item-text="FullName"
              item-value="ID"
            ></v-select>
          </v-flex>
          <v-flex lg4 md4 sm12>
            <v-select
              :disabled="!roleEditable"
              label="Nhân viên sale"
              :items="s_staffs"
              v-model="currentCustomer.SaleID"
              item-text="FullName"
              item-value="ID"
            ></v-select>
          </v-flex>
          <v-flex lg6 md6 sm12>
            <v-select
              :disabled="!roleEditable"
              label="Level"
              :items="levels"
              v-model="currentCustomer.LevelID"
              item-text="VIPName"
              item-value="ID"
              :rules="requireRules"
            ></v-select>
          </v-flex>
          <v-flex lg6 md6 sm12>
            <v-select
              :disabled="!roleEditable"
              label="Trạng thái"
              :items="customerStatus"
              v-model="currentCustomer.Status"
              item-text="name"
              item-value="value"
              :rules="requireRules"
            ></v-select>
          </v-flex>
          <v-flex lg6 md6 sm12>
            <v-switch
              v-model="currentCustomer.IsSpecialFee"
              label="Áp dụng mức phí đặc biệt (đặt -1 để tính theo mặc định)"
              class="input-group--focused"
              :disabled="!roleEditable"
            ></v-switch>
          </v-flex>
          <v-flex lg6 md6 sm12>
            <v-switch
              v-model="currentCustomer.IsShowVolume"
              label="Hiển thị kích thước kiện"
              class="input-group--focused"
              :disabled="!roleEditable"
            ></v-switch>
          </v-flex>
          <v-flex lg3 md3 sm12>
            <v-text-field
              type="number"
              :disabled="!currentCustomer.IsSpecialFee || !roleEditable"
              step=".1"
              v-model="currentCustomer.FeeBuy"
              label="Phí mua hàng (%)"
            ></v-text-field>
          </v-flex>
          <v-flex lg3 md3 sm12>
            <v-text-field
              type="number"
              :disabled="!currentCustomer.IsSpecialFee || !roleEditable"
              step="1"
              v-model="currentCustomer.FeeWeight"
              label="Phí cân nặng"
            ></v-text-field>
          </v-flex>
          <v-flex lg3 md3 sm12>
            <v-text-field
              type="number"
              :disabled="!currentCustomer.IsSpecialFee || !roleEditable"
              step="1"
              v-model="currentCustomer.FeeVolumn"
              label="Phí khối"
            ></v-text-field>
          </v-flex>
          <v-flex lg3 md3 sm12></v-flex>
          <v-flex lg2 md2 sm12>
            <v-switch
              :disabled="!roleEditable"
              v-model="currentCustomer.IsWeightByVolume"
              label="Tính cân quy đổi"
              class="input-group--focused"
            ></v-switch>
          </v-flex>
          <v-flex lg2 md2 sm12>
            <v-switch
              :disabled="!roleEditable"
              v-model="currentCustomer.IsVolume"
              label="Tính khối"
              class="input-group--focused"
            ></v-switch>
          </v-flex>
          <v-flex lg2 md2 sm12>
            <v-switch
              :disabled="!roleEditable"
              v-model="currentCustomer.IsDepositRate"
              label="Áp dụng tỷ lệ cọc"
              class="input-group--focused"
            ></v-switch>
          </v-flex>
          <v-flex lg2 md2 sm12>
            <h-currency-input
              :disabled="!currentCustomer.IsDepositRate || !roleEditable"
              :decimal="0"
              v-model="currentCustomer.DepositRate"
              label="Tỷ lệ cọc (%)"
            ></h-currency-input>
          </v-flex>
          <v-flex lg2 md2 sm12>
            <h-currency-input
              :disabled="!roleEditable"
              :decimal="0"
              v-model="currentCustomer.ExchangeRate"
              label="Tỷ giá"
            ></h-currency-input>
          </v-flex>
          <v-flex lg2 md2 sm12>
            <h-currency-input
              :disabled="!roleEditable"
              :decimal="0"
              v-model="currentCustomer.Density"
              label="Tỷ trọng cân"
            ></h-currency-input>
          </v-flex>
          <v-flex sm12 md12 lg12>
            <v-widget title="Lịch sử giao dịch">
              <div slot="widget-content">
                <hpo-filter
                  :headers="tradeHeader"
                  :viewName="viewName"
                  v-on:applyFilter="applyFilter"
                  v-on:quickFilter="quickFilter"
                ></hpo-filter>
                <v-data-table
                  :headers="tradeHeader"
                  :items="trades"
                  :server-items-length="total_rows"
                  :options.sync="pagination"
                  :mobile-breakpoint="100"
                >
                  <template v-slot:item="{ item }">
                    <tr>
                      <td>
                        {{
                          item.CreatedDate | display_date("DD-MM-YYYY HH:mm:ss")
                        }}
                      </td>
                      <td>{{ item.HContent }}</td>
                      <td class="text-end">
                        {{ item.Type == 1 ? "-" : "+"
                        }}{{ item.Amount | currency }}
                      </td>
                      <td>{{ item.TradeType | trade_type }}</td>
                      <td class="text-end">{{ item.MoneyLeft | currency }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </div>
            </v-widget>
          </v-flex>
        </v-layout>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { mapState } from "vuex";
import phonecode from "@/configs/phonecode";
import configs from "@/configs";
import md5 from "md5";
import { trade_type } from "@/commons/hpod";
import VWidget from "@/components/VWidget";
import Filtering from "@/components/Filtering";
export default {
  filters: {
    trade_type,
  },
  components: {
    VWidget,
    "hpo-filter": Filtering
  },
  data() {
    let dataType = configs.DATA_TYPE;
    return {
      valid: true,
      pwdWarning: "Mật khẩu không khớp.",
      password: "",
      rePassword: "",
      customerStatus: configs.CUSTOMER_STATUS_LIST,
      requireRules: [(v) => !!v || "Trường dữ liệu không được để trống."],
      nameRules: [
        (v) => !!v || "Trường dữ liệu không được để trống.",
        (v) =>
          (v || "").indexOf(" ") < 0 ||
          "Tên đăng nhập không được chứa dấu cách",
        (v) => !/(?=.*[A-Z])/.test(v) || "Tên đăng nhập không được viết hoa",
        (v) =>
          /^[\x00-\x7F]*$/.test(v) ||
          "Tên đăng nhập chỉ bao gồm chữ cái a-z và số 0-9",
      ],
      tradeHeader: [
        {
          text: "Ngày giờ",
          value: "CreatedDate",
          sortable: true,
          filterable: true,
          quickSearch: false,
          dataType: dataType["Date"],
        },
        {
          text: "Nội dung",
          value: "HContent",
          sortable: true,
          filterable: true,
          quickSearch: true,
          dataType: dataType["String"],
        },
        {
          text: "Số tiền",
          value: "Amount",
          align: "end",
          sortable: true,
          filterable: true,
          quickSearch: false,
          dataType: dataType["Number"],
        },
        {
          text: "Loại giao dịch",
          value: "TradeType",
          sortable: true,
          filterable: true,
          dataType: dataType["Enum"],
          values: configs.TRADE_TYPE,
        },
        {
          text: "Số dư",
          value: "MoneyLeft",
          align: "end",
          sortable: true,
          filterable: true,
          quickSearch: false,
          dataType: dataType["Number"],
        },
      ],
      pagination: { ...configs.PAGINATION, sortBy: ["ID"]},
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      viewName: "historypaywallet",
      filterConditions: [],
      quickFilterConditions: [],
    };
  },
  computed: {
    ...mapState("customer", {
      loading: "loading",
      currentCustomer: "selected",
    }),
    ...mapState({
      trades: (state) => state.historypaywallet.all.data,
      total_rows: (state) => state.historypaywallet.all.total,
      warehouses: (state) => state.commons.stores,
      chinaStores: (state) => state.commons.chinaStores,
    }),
    ...mapState({
      levels: (state) => state.customerLevel.all.data,
      p_staffs: (state) =>
        _.filter(state.commons.all_users, function(o) {
          return (
            (o.RoleType & configs.ROLE_TYPE.Purchase) ==
            configs.ROLE_TYPE.Purchase
          );
        }),
      s_staffs: (state) =>
      _.filter(state.commons.all_users, function(o) {
        return (
          (o.RoleType & configs.ROLE_TYPE.Sale) ==
          configs.ROLE_TYPE.Sale
        );
      }),
      cs_staffs: (state) =>
        _.filter(state.commons.all_users, function(o) {
          return (
            (o.RoleType & configs.ROLE_TYPE.CustomerService) ==
            configs.ROLE_TYPE.CustomerService
          );
        }),
    }),
    customerId() {
      return this.$route.params.Pid;
    },
    prefixes() {
      return _.map(phonecode, "dial_code");
    },
    passwordConfirmationRule() {
      return this.password === this.rePassword || this.pwdWarning;
    },
    roleAdmin() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
    },
    roleEditable() {
      return (
        (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin || (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Payment) == configs.ROLE_TYPE.Payment || (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Manager) == configs.ROLE_TYPE.Manager
      );
    },
  },
  watch: {
    pagination: {
      handler: function(val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions)
          ? filterConditions[this.viewName]
          : [];
        this.filter_data();
      },
      deep: true,
    }
  },
  methods: {
    filter_data: function() {
      var param = {
        pagination: this.pagination,
        search_term: this.search,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions,
      };
      param.filter.push({
        column: "UID",
        value: Number(this.customerId),
        condition: "equal",
      });
      this.$store.dispatch("historypaywallet/getList", param);
    },
    refreshData() {
      if (this.customerId > 0) {
        this.$store.dispatch("customer/getCustomerDetail", this.customerId);
        this.filter_data();
      }
      else {
        this.$store.commit("customer/setCustomerDetail", {data: {}});
        this.$store.commit("historypaywallet/setList", {});
      }
    },
    resetPassword() {
      this.currentCustomer.Password = md5("123@123");
      this.$store.dispatch("customer/setCustomerDetail", {
        data: this.currentCustomer,
        id: this.customerId,
        resetPwd: true,
      });
    },
    saveData() {
      if (this.passwordConfirmationRule !== true) {
        window.getApp.$emit("APP_RESOURCE_FAILED", this.pwdWarning);
      }
      if (this.password !== "") {
        this.currentCustomer.Password = md5(this.password);
      }
      this.$store.dispatch("customer/setCustomerDetail", {
        data: this.currentCustomer,
        id: this.customerId,
      });
      window.getApp.$emit("APP_NAVIGATE", "CustomerList");
    },
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy;
      let sortDesc = this.pagination.sortDesc;
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    },
  },
  mounted() {
    this.refreshData();
    this.$root.$emit("REQUEST_ROOT_OPTION", {});
    this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
    this.$root.$on("REQUEST_CREATE_DATA", this.resetPassword);
    this.$store.dispatch("commons/getAllUsers");
    let pagingReq = _.cloneDeep(configs.PAGINATION);
    pagingReq.sortDesc = [false];
    this.$store.dispatch("commons/getAllStores");
    this.$store.dispatch("commons/getAllChinaStores");
    this.$store.dispatch("customerLevel/getCustomerLevelList", {
      pagination: pagingReq,
    });
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
    this.$root.$off("REQUEST_CREATE_DATA", this.resetPassword);
  },
};
</script>

<style></style>
